import { Button, Input, Title } from "../../uikit";
import Header from "../Header";
import { useNavigate } from "react-router";

import { useTranslation } from "react-i18next";

import { DOMAIN } from "../../consts";
import { useState } from "react";
import ErrorMessage from "../ErrorMessage";

export default function PasswordRecovery({ setVariant = () => {} }) {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const [username, setUsername] = useState("");

  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [errorMessage, setErrorMessage] = useState("");

  const requestAuth = async (path, body) => {
    const response = await fetch(DOMAIN + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    let payload = {};
    try {
      payload = await response.json();
    } catch {}

    if (!response.ok) {
      const detail = payload?.detail;
      const message =
        typeof detail === "string"
          ? detail
          : payload?.message || "Something went wrong";
      throw new Error(message);
    }

    return payload;
  };

  const generateCode = async () => {
    try {
      setIsLoading(true);
      if (username == "") {
        setErrorMessage("Fill all fields");
        return;
      }
      setErrorMessage("");
      const data = {
        username,
      };
      await requestAuth("/auth/password-recovery/request", data);
      setErrorMessage("");
      setIsCodeSent(true);
    } catch (e) {
      setErrorMessage(t(e?.message || "Something went wrong"));
    } finally {
      setIsLoading(false);
    }
  };

  const changePassword = async () => {
    try {
      setIsLoading(true);
      if (code == "" || newPassword == "") {
        setErrorMessage("Fill all fields");
        return;
      }

      if (newPassword.length < 8) {
        setErrorMessage(t("Password too short"));
        return;
      }

      setErrorMessage("");
      const data = {
        code,
        password: newPassword,
      };
      await requestAuth("/auth/password-recovery/confirm", data);
      setVariant("login-email");
    } catch (e) {
      setErrorMessage(t(e?.message || "Something went wrong"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="column card wide">
      <Header
        isBack={true}
        backCallback={() => setVariant("start")}
        className="row"
      >
        <Title level="1" weight="3">
          {t("Password recovery")}
        </Title>
      </Header>
      {isCodeSent ? (
        <>
          <div className="row">
            {t("The recovery code has been sent to your email address")}
          </div>
          <Input
            className="wide mb-1"
            header={t("Recovery code")}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <Input
            type="password"
            className="wide mb-1"
            header={t("Password")}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Button
            mode="filled"
            size="l"
            className="row"
            onClick={changePassword}
            loading={isLoading}
            disabled={isLoading}
          >
            {t("Change password")}
          </Button>
        </>
      ) : (
        <>
          <Input
            className="wide mb-1"
            header={t("Email")}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Button
            mode="filled"
            size="l"
            className="row"
            onClick={generateCode}
            loading={isLoading}
            disabled={isLoading}
          >
            {t("Send recovery code")}
          </Button>
        </>
      )}
      <ErrorMessage errorMessage={errorMessage} />
    </div>
  );
}
